export const UNLOCK = 0;
export const MYOWNLOCK = 1;
export const OTHERSLOCK = 2;

export const IconName = {
  LabelCtrl: 'icon_label_form',
  CalendarCtrl: 'icon_calendar_form',
  InputCtrl: 'icon_input_form',
  SelectCtrl: 'icon_select_form',
  CascaderCtrl: 'icon_cascade_choice',
  ReporterCtrl: 'icon_report_controls',
  RadioCtrl: 'icon_radio_form',
  CheckboxCtrl: 'icon_check_form',
  DatePickerCtrl: 'icon_date_picker_form',
  TreeCtrl: 'icon_tree_form',
  ButtonCtrl: 'icon_btn_form',
  SingleList: 'icon_single_table',
  TableCtrl: 'icon_table_form',
  TodoCtrl: 'icon_to_do_list',
  Webview: 'icon_web_page',
  Circle: 'icon_circle_graphics',
  Rect: 'icon_rectangular_graphics',
  Oval: 'icon_ellipse_graphics',
  RoundRect: 'icon_r_rectangular_graphics',
  Polygon: 'icon_polygon_graphics',
  Arc: 'icon_arc_graphics',
  Star: 'icon_star_graphics',
  Triangle: 'icon_triangle_graphics',
  Hexagon: 'icon_custom',
  lineArrow: 'icon_line',
  RealAlarm: 'icon_realtimealarm_contorls',
  HistoryAlarm: 'icon_historicalalarm_contorls',
  LiveStreaming: 'icon_video_controls',
  VideoCtrl: 'icon_video_controls',
  VideoWallCtrl: 'icon_video_wall',
  IntervalCtrl: 'icon_setinterval',
  TrendChart: 'icon_trend_contorls',
  LineChart: 'icon_polyline_chart',
  SplineChart: 'icon_graph_chart',
  Column: 'icon_histogram_chart',
  Dashboard: 'icon_dashboard_chart',
  Gauge: 'icon_t_dashboard_chart',
  Scatter: 'icon_scatter_chart',
  Bubble: 'icon_bubble_chart',
  Area: 'icon_area_chart',
  Pie: 'icon_piechart_chart',
  AnnularChart: 'icon_annular_chart',
  SpcChart: 'icon_spc',
  BarChart: 'icon_histogram_barchart',
  Ellipse: 'icon_area_chart',
  Group: 'icon_area_chart',
  Funnel: 'icon_funnel_chart',
  SpiderChart: 'icon_radar_chart',
  HeatMap: 'icon_map_chart',
  image: 'icon_pic_graphics',
  UploadImg: 'icon_pic_graphics',
  UploadCtrl: 'btn_upload',
  TabsCtrl: 'icon_label_page',
  Edge: 'icon_brokenline_graphics',
  Pipe: 'icon_pipe_graphics',
  Text: 'icon_text_graphics',
  dataLink: 'icon_linterlinkade_graphics_1',
  Shape: 'icon_pen_graphice_1',
  LineCtrl: 'btn_minus_form',
  HiddenFieldCtrl: 'file-hidden',
  StartWorkProcess: 'icon_process_list',
  StartWorkProcessBtn: 'icon_initiate_process',
  BreadcrumbCtrl: 'icon_breadcrumb',
  SearchCtrl: 'icon_search',
  CarouselCtrl: 'icon_slider',
  CustomTemp: 'mokuai', // 自定义模板库icon
  CustomComp: 'icon_code',
  Grid: 'icon_grid',
  ZoneCtrl: 'icon_block',
  HTContainer: 'icon_ht_container',
  ProgressChart: 'icon_progress_chart',
  TimeCtrl: 'icon_time_form',
  DateCtrl: 'icon_date_form'
};
